var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7196_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7196_570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_2",
    d: "M3.7563 15.5834C3.39088 15.5834 3.07623 15.4515 2.81234 15.1876C2.54845 14.9237 2.4165 14.609 2.4165 14.2436V5.75654C2.4165 5.39112 2.54845 5.07647 2.81234 4.81258C3.07623 4.54869 3.39088 4.41675 3.7563 4.41675H16.2434C16.6185 4.41675 16.9356 4.54869 17.1946 4.81258C17.4537 5.07647 17.5832 5.39112 17.5832 5.75654V14.2436C17.5832 14.609 17.4537 14.9237 17.1946 15.1876C16.9356 15.4515 16.6185 15.5834 16.2434 15.5834H3.7563ZM16.4998 6.80612L10.3636 10.4184C10.3061 10.4547 10.2468 10.4832 10.1857 10.504C10.1246 10.5249 10.0626 10.5353 9.99984 10.5353C9.93039 10.5353 9.87192 10.5249 9.82442 10.504C9.77678 10.4832 9.7215 10.4567 9.65859 10.4247L3.49984 6.80612V14.2436C3.49984 14.3185 3.52387 14.3799 3.57192 14.428C3.61998 14.4761 3.68143 14.5001 3.7563 14.5001H16.2434C16.3182 14.5001 16.3797 14.4761 16.4278 14.428C16.4758 14.3799 16.4998 14.3185 16.4998 14.2436V6.80612ZM9.99984 9.22925L16.3509 5.50008H3.66963L9.99984 9.22925ZM3.49984 6.53737V6.70862V5.88946V5.90383V5.87737V6.7105V6.53904V14.5001V6.53737Z",
    fill: "#001E63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.19c65099fb0725e38b288220dc3c2f98.svg";
export { ForwardRef as ReactComponent };